<template>
  <div>
    <div class="top">
      <Breadcrumb :options="breadcrumb" />
      <!-- <Wxts :wxtsList="wxtsList" /> -->
    </div>

    <div class="info_form">
      <el-form ref="form" :model="form" :label-width="labelWidth" :rules="rules">
        <el-row>
          <el-col :span="8" v-for="(c, i) in certificates" :key="'certificate' + i">
            <Certificate
              class="self"
              :labelWidth="labelWidth"
              :viewMode="viewMode"
              :form="c.data"
              :config="c"
              :formCtrls="c.ctrls"
              :remindCtrl="c.remindCtrl"
              :options1="remindCtrlOptions1"
              :options2="remindCtrlOptions2"
              @onChange="onChange"
            />
          </el-col>
        </el-row>
      </el-form>
    </div>

    <div class="btns">
      <SubmitBtn @onSubmit="onSubmit"></SubmitBtn>
      <el-button @click="cancel">取 消</el-button>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  computed: {
    ...mapState(["user"]),
  },
  data() {
    return {
      breadcrumb: [
        { name: "车辆管理", path: `/vehicle/manage` },
        { name: "车辆列表", path: `/vehicle/manage` },
        { name: "车辆证件" },
      ],
      wxtsList: [
        {
          name: "如需增减车辆证件类型，可以在【系统设置】",
          path: "/system/documentConfig",
          pathName: "【车辆证件配置】",
          tailName: "处维护。",
        },
      ],
      baseUrl: "car",
      labelWidth: "180px",
      viewMode: false,
      form: {
        data: [],
      },
      rules: {},
      certificates: [],
      remindCtrlOptions1: [],
      remindCtrlOptions2: [],
    };
  },
  methods: {
    setValue(o, key, value) {
      if (value && typeof value === "object") {
        o[key] = value.map((v) => {
          let result = v;
          if (v.response && v.response.photo) {
            result = { url: v.response.photo };
          }
          return result;
        });
      } else {
        o[key] = value;
      }
    },
    onChange({ key, value, data }) {
      console.log(key, value, type_id);
      // console.log('form before', { ...this.form });
      const { type_id, image, maturitytime, pronum, reminder } = data;
      if (this.form.data && this.form.data[0]) {
        let boo = false;
        this.form.data.map((o) => {
          if (o.type_id === type_id) {
            // console.log({ ...o })
            this.setValue(o, key, value);
            boo = true;
          }
        });
        if (!boo) {
          const o = {
            type_id,
            image: image || null,
            maturitytime: maturitytime || null,
            pronum: pronum || null,
            reminder: reminder || null,
          };
          this.setValue(o, key, value);
          this.form.data.push(o);
        }
      } else {
        const o = {
          type_id,
          image: image || null,
          maturitytime: maturitytime || null,
          pronum: pronum || null,
          reminder: reminder || null,
        };
        this.setValue(o, key, value);
        this.form["data"] = [o];
      }
      console.log("form", { ...this.form });
    },
    setData(list) {
      this.form.data = this.form.data || [];
      list.map((v) => {
        const { type_name } = v;
        const d = { ...v };
        delete d.type_name;
        const o = {
          label: type_name + "正反面",
          data: v,
          ctrls: [
            {
              label: "上传图片",
              keyName: "image",
              type: "file",
              ptype: "document",
              tips: "最多上传15张图片",
              max: 15,
            },
            {
              label: "到期时间",
              keyName: "maturitytime",
              err: "请选择时间",
              type: "date",
            },
          ],
          remindCtrl: {
            label: "提醒时间",
            key1: "pronum",
            key2: "reminder",
          },
        };
        this.certificates.push(o);
        this.form.data.push(d);
      });
      // console.log('list', list)
      // console.log(this.certificates)
      // console.log('form start', { ...this.form });
    },
    getData(params = {}) {
      this.post(
        `${this.baseUrl}/documentrec`,
        params,
        (res) => {
          console.log(res);
          const { list, tanday, interday } = res;
          if (list && list.length) {
            this.setData(list);
          } else if (list.length == 0) {
            this.$message({
              type: "error",
              message: "暂无数据,请前往【系统设置】【车辆证件配置】处维护项",
            });
          } else {
            this.$message({
              type: "error",
              message: "加载失败，请稍后再试！",
            });
          }
          if (tanday && tanday.length) {
            this.remindCtrlOptions1 = tanday.map((val) => {
              return {
                label: val.name,
                value: val.intime,
              };
            });
          }
          if (interday && interday.length) {
            this.remindCtrlOptions2 = interday.map((val) => {
              return {
                label: val.name,
                value: val.intime,
              };
            });
          }
        },
        (err) => {
          console.log(err);
          this.$message({
            type: "error",
            message: "获取数据失败，请稍后重试！",
          });
        }
      );
    },
    onSubmit() {
      // console.log({ ...this.form });
      const validate = this.$refs["form"].validate;
      const validatePass = this.$refs["form"].validatePass;
      // console.log(this.$refs['form']);
      // console.log(validatePass);
      if (validate) {
        validate((valid) => {
          // console.log(valid)
          if (valid) {
            this.submitConfirm();
          } else {
            console.log("验证不通过");
            console.log({ ...this.form });
            this.$message({
              type: "error",
              message: "请修改错误信息",
            });
            return false;
          }
        });
      } else if (validatePass) {
        validatePass(() => {
          this.submitConfirm();
        });
      }
    },
    submitConfirm() {
      this.$confirm("确认提交吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(this.submitReq)
        .catch(() => {});
    },
    submitReq(data) {
      this.loading = true;
      let url = `${this.baseUrl}/addocument`;
      const params = {
        userid: this.user.id,
      };
      this.paramsPackage(params, this.form);
      if (this.carid) {
        params["carid"] = this.carid;
      }
      if (this.car_type) {
        params["car_type"] = this.car_type;
      }
      // console.log(data)
      if (typeof data === "object") {
        for (const key in data) {
          if (Object.hasOwnProperty.call(data, key)) {
            params[key] = data[key];
          }
        }
      }
      // console.log(url, params)
      this.post(
        url,
        params,
        ({ msg }) => {
          if (msg === "success") {
            this.$message({
              type: "success",
              message: "提交成功!",
            });
            this.$router.back();
          } else {
            this.$message({
              type: "error",
              message: msg,
            });
          }
          this.loading = false;
        },
        (err) => {
          console.log(err);
          this.$message({
            type: "error",
            message: "提交失败，请稍后重试！",
          });
        }
      );
    },
    paramsPackage(params, object) {
      for (const key in object) {
        if (Object.hasOwnProperty.call(object, key)) {
          // console.log(typeof object[key])
          const value = object[key];
          if (value && typeof value === "object") {
            // console.log(key, value)
            params[key] = value.map((v) => {
              let result = v;
              if (v.response && v.response.photo) {
                result = { url: v.response.photo };
              }
              return result;
            });
          } else {
            params[key] = value;
          }
        }
      }
    },
    cancel() {
      this.$router.back();
    },
    setQueryParams() {
      const { id, car_type, license } = this.$route.query;
      const params = {};
      if (id) {
        params["carid"] = id;
        this["carid"] = id;
      }
      if (car_type) {
        params["car_type"] = car_type;
        this["car_type"] = car_type;
      }
      if (license) this.breadcrumb[2].name = `${license}车辆证件`;
      return params;
    },
  },
  created() {
    const params = this.setQueryParams();
    this.getData(params);
  },
  mounted() {},
};
</script>

<style lang="less" scoped>
/deep/ .info_form {
  padding: 0;
  border-radius: 5px;
  background-color: #fff;
  box-shadow: 0px 0px 10px rgb(0 0 0 / 3%);

  .el-form {
    .el-form-item {
      padding: 0 20px 0 0;
      margin-bottom: 20px;

      .el-input,
      .el-textarea {
        width: 300px;
      }

      .el-upload__tip {
        left: 107px;
        top: 2px;
        width: 180px;
      }

      .el-button--small {
        padding: 12px 21px;
        font-size: 14px;
      }
    }

    .subform {
      &::before {
        width: 110%;
        height: 10px;
        background: #f9f9f9;
        content: "";
      }

      &:first-child {
        &::before {
          display: none;
        }
      }
    }

    .el-row {
      overflow: hidden;

      .el-col:nth-child(3n + 1) {
        clear: left;
      }
    }
  }
}

.instyle {
  display: inline-block;
}

.bainfo {
  padding-bottom: 20px;
}

.info_form .el-form .subform {
  margin-bottom: 0;
}

/*.info_form .el-form .el-form-item:nth-child(9) {
  display: block;
}*/
/deep/ .el-form .el-form-item.remind .content {
  display: block;

  .left:nth-child(2) {
    margin-left: 180px;
    margin-top: 20px;
  }
}

/deep/ .self {
  > .el-form-item__label {
    float: none !important;
    display: block;
    margin: 39px 0 18px 112px;
    text-align: left;
    font-size: 18px;
    color: #333;
  }

  > .el-form-item__content {
    margin-left: 0 !important;
  }
}

.el-form .el-row:nth-child(4) .el-col-8 .subform::before {
  display: none;
}

.el-form .el-row:nth-child(4) .el-col-16 .subform::before {
  display: none;
}

.el-col-16 .self {
  margin-left: -54px;
}

.el-row .el-col .self:first-child {
  margin-bottom: 40px;
}

/deep/.info_form .el-form .el-row:nth-child(2) {
  padding-bottom: 20px;
}

/deep/ .subform .el-row .el-col-8 .el-form-item:last-child {
  margin-bottom: 40px;
}

.tit_label {
  margin: 26px 0 26px 112px;
  font-size: 18px;
  color: #333;
}

/deep/.el-icon-arrow-right:before {
  content: "";
}

/deep/ .breadcrumb .el-icon-arrow-right:before {
  content: "\e6e0";
}

.btns {
  margin: 40px 0 60px 180px;
}

.top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-right: 20px;
}
</style>
